export const area = {
  codice: null,
  dataInizioVal: null,
  dataFineVal: null,
  title: null,
  dataInserimento: null,
  dataVariazione: null,
  image: null,
};